<script lang="ts">
  import {alerts} from 'Store/globalStore';
  import {slide} from 'svelte/transition';
  import {sineInOut} from 'svelte/easing';
  import type {Alert} from 'Store/globalStore';
  import {embeddedWebComponent} from 'Store/embedded/embeddedFlowStore';

  const dismiss = (alert: Alert) => {
    alerts.remove(alert);
  };
</script>

<template>
  <div class="w-100 alert-wrapper" class:embedded={$embeddedWebComponent}>
    {#each $alerts as alert}
      <div
        transition:slide={{duration: 300, easing: sineInOut}}
        class="d-flex flex-column mb-2"
      >
        <div
          class="alert alert-{alert.type} rounded-0 border-0 w-100 mb-0"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          {alert.message}
          <button
            type="button"
            class="close text-{alert.type}"
            aria-label="Close"
            on:click={() => dismiss(alert)}
          >
            <i class="fal fa-fw fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    {/each}
  </div>
</template>

<style lang="postcss">
  .alert-wrapper {
    z-index: 11;
    opacity: 0.8;
    position: absolute;

    &.embedded {
      opacity: 0.95;
      position: sticky;
      top: 0;
    }
  }
</style>
